import React, { ChangeEvent } from "react";
import styles from "./textarea.module.scss";

export interface TextareaProps {
  id?: string;
  label: string;
  placeholder: string;
  value: string | number;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  rows?: number;
}
const cssClassName = "textarea";
export const Textarea = ({
  id,
  label,
  placeholder,
  value,
  onChange,
  rows,
}: TextareaProps) => {
  return (
    <div className={styles[`${cssClassName}`]}>
      <label htmlFor={id} className={styles[`${cssClassName}__label`]}>
        {label}
      </label>
      <textarea
        name={id}
        id={id}
        rows={rows}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={styles[`${cssClassName}__textarea`]}
      />
    </div>
  );
};
